import React, { useContext, useState, useEffect } from "react";
import "./Home.css";
import Perfil from "../../assets/imgs/profile-jacques.webp";
import { LanguageContext } from "../../context/LanguageContext";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function Home({ scrollToComponent }) {
  const { language } = useContext(LanguageContext);
  const [showScrollButton, setShowScrollButton] = useState(true);

  useEffect(() => {
    let frame = 0;
    const handleScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const next = window.scrollY < 40;
        setShowScrollButton((prev) => (prev === next ? prev : next));
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  const textContent = {
    en: {
      kicker: "AI Engineer · Natal, Brazil",
      headline: "Production AI for enterprise data.",
      description:
        "I design the full chain: semantic models on messy high-volume data, large-scale multi-agent systems, MCP-backed integrations and automations, and the LLMOps that keep the answers honest in production.",
      specialization: "Multi-agent · MCP · Integrations · Automation · Data engineering · LLMOps",
      contactButton: "Get in touch",
      resumeButton: "Resume",
    },
    pt: {
      kicker: "Engenheiro de IA · Natal, Brasil",
      headline: "IA de produção para dados empresariais.",
      description:
        "Eu desenho a cadeia inteira: modelos semânticos sobre dados bagunçados e de alto volume, sistemas multi-agente em escala, integrações e automações via MCP, e o LLMOps que mantém a resposta honesta em produção.",
      specialization: "Multi-agente · MCP · Integrações · Automação · Engenharia de dados · LLMOps",
      contactButton: "Falar comigo",
      resumeButton: "Currículo",
    },
  };

  const { kicker, headline, description, specialization, contactButton, resumeButton } =
    textContent[language];

  return (
    <section className="home-wrapper" aria-label="Introduction">
      <div className="shapes-wrapper">
        <div className="shape-small"></div>
        <div className="shape-small-1"></div>
        <div className="home-container page-width">
          <div className="home-content slide-in">
            <p className="home-kicker">{kicker}</p>
            <h1>{headline}</h1>
            <p className="home-lead">{description}</p>
            <p className="home-specialization">{specialization}</p>
            <div className="home-socials">
              <a href="https://github.com/JacquesGomes/" target="_blank" rel="noreferrer" aria-label="GitHub">
                <i className="uil uil-github-alt"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/jacques-gomes-627739240/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <i className="uil uil-linkedin-alt"></i>
              </a>
              <a href="https://www.instagram.com/jacquesgomess/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <i className="uil uil-instagram"></i>
              </a>
              <a
                href="https://wa.me/5584994514529?text=Olá%20Jacques,%20vi%20seu%20perfil%20e%20gostaria%20de%20discutir%20um%20projeto%20de%20IA."
                aria-label="WhatsApp"
                target="_blank"
                rel="noreferrer"
              >
                <i className="uil uil-whatsapp"></i>
              </a>
              <a href="mailto:jacquesgomes66@gmail.com" aria-label="Email">
                <i className="uil uil-envelope"></i>
              </a>
            </div>
            <div className="home-btn-wrapper">
              <a
                className="main-btn"
                href="https://wa.me/5584994514529?text=Olá%20Jacques,%20vi%20seu%20perfil%20e%20gostaria%20de%20discutir%20um%20projeto%20de%20IA."
                target="_blank"
                rel="noreferrer"
              >
                {contactButton}
              </a>
              <a
                className="main-btn-alt"
                href="https://www.linkedin.com/in/jacques-gomes-627739240/"
                target="_blank"
                rel="noreferrer"
              >
                {resumeButton}
              </a>
            </div>
          </div>
          <div className="half-image">
            <img className="slide-in-right" src={Perfil} alt="Jacques Gomes, AI Engineer" />
          </div>
        </div>
        {showScrollButton && (
          <button className="scroll-icon-btn" onClick={() => scrollToComponent("portfolio")} aria-label="Portfolio">
            <ArrowDownwardIcon className="scroll-icon" />
          </button>
        )}
      </div>
    </section>
  );
}

export default Home;
